import { Control, FieldArrayWithId } from "react-hook-form";
import { FacilityDraftFormValues, SourceCollectionKey, SourceSectionConfig, UnitOption } from "../types/facilityDrawer.types";
import AddRecordButton from "./AddRecordButton";
import FacilitySectionCard from "./FacilitySectionCard";
import SourceRecordCard from "./SourceRecordCard";
import SourceSectionEmptyHint from "./SourceSectionEmptyHint";
import VolumeRecordFields from "./VolumeRecordFields";

interface VolumeSourceSectionProps {
  control: Control<FacilityDraftFormValues>;
  config: SourceSectionConfig;
  fields: FieldArrayWithId<FacilityDraftFormValues, SourceCollectionKey, "id">[];
  sourceOptions: UnitOption[];
  onAdd: () => void;
  onRemove: (index: number) => void;
}

const VolumeSourceSection = ({
  control,
  config,
  fields,
  sourceOptions,
  onAdd,
  onRemove
}: VolumeSourceSectionProps) => (
  <FacilitySectionCard
    label={config.title}
    action={<AddRecordButton label={config.title.toLowerCase()} onClick={onAdd} />}
  >
    {fields.length === 0 && <SourceSectionEmptyHint sectionLabel={config.title} />}
    <div className="tw-space-y-3">
      {fields.map((field, index) => (
        <SourceRecordCard key={field.id} index={index} onRemove={() => onRemove(index)}>
          <VolumeRecordFields control={control} index={index} config={config} sourceOptions={sourceOptions} />
        </SourceRecordCard>
      ))}
    </div>
  </FacilitySectionCard>
);

export default VolumeSourceSection;
